// Toggles an opaque state on the desktop nav bar once the page is
// scrolled — see .header--scrolled in _header.scss for the visual change.
// The scroll listener itself runs at every width, but its effect is
// scoped to desktop-only via CSS, matching how the rest of the header's
// responsive states are handled in this theme.

const SCROLL_THRESHOLD = 10;

const headerScroll = {
	init: function () {
		const header = document.querySelector('.header');
		if (!header) return;

		const updateScrolledState = () => {
			header.classList.toggle('header--scrolled', window.scrollY > SCROLL_THRESHOLD);
		};

		updateScrolledState();
		window.addEventListener('scroll', updateScrolledState, {passive: true});
	}
};

export default headerScroll;
